import React from 'react';
import Switch from 'react-bootstrap-switch';
import {Trans} from 'react-i18next';

export default function CustomSwitch({field, form, ...props}) {
  const {onText, offText, value, disabled, onCallback} = props;
  let customOnText =
    onText === undefined ? (
      <Trans i18nKey="c.f.switch.button.on">On</Trans>
    ) : (
      onText
    );
  let customOffText =
    offText === undefined ? (
      <Trans i18nKey="c.f.switch.button.off">Off</Trans>
    ) : (
      offText
    );

  return (
    <Switch
      disabled={!!disabled}
      value={value}
      onText={customOnText}
      offText={customOffText}
      animate={false}
      tristate={false}
      onChange={(el, state) => {
        form.setFieldValue(field.name, state);
        onCallback && onCallback(state);
      }}
    />
  );
}
